import React from 'react';
import { Link } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RaisedButton from 'material-ui/RaisedButton';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import Tooltip from 'material-ui/internal/Tooltip';

import IconButton from 'material-ui/IconButton';
import Check from 'material-ui/svg-icons/av/playlist-add-check';

import styles from 'styles';

class VesselListRow extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            item: props.item,
        };

    }

    UNSAFE_componentWillReceiveProps(newProps) {

    }

    render() {
        const { item } = this.props;
        const { modifiedFields } = this.props.item;
        
        let fields = [];
        if(modifiedFields) {
            fields = modifiedFields.map(item => item.updatedField);
        }

        let showModifiedFields = () => {
            return (
                <TableRowColumn style={styles.tableRowColumnModifed}>
                    <p>
                        {fields.includes('typeByConstruction') ? 'Type by construction' : null} <br/>
                        {fields.includes('geared') ? 'Geared' : null} <br/>
                        {fields.includes('deadWeight.sTpc') ? 'TPC' : null} <br/>
                        {fields.includes('grabbed') ? 'Grab fitted' : null} <br/>
                        {fields.includes('registerClass') ? 'Register class' : null}<br/>
                    </p>
                </TableRowColumn>
            );
        }

        return (
            <TableRow>
                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    {item.imoNumber}
                    {/*imoNumber*/}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    {item.name}
                    {/*name*/}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    {item.blt}
                    {/*year*/}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {item.typeByPurpose}
                    {/*Type*/}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {item.registerClass && item.registerClass.name}
                    {/*class*/}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {item.gearV2All && item.gearV2All.join(', ')}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    {item.capacity.grain}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    {item.dw.summer}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnModifed}>
                    { showModifiedFields() }
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                    <RaisedButton
                        label='Edit'
                        primary
                        containerElement={<Link to={`/vessels/${item._id}`} />}
                    />
                </TableRowColumn>
            </TableRow>
        );
    }
}

export default connect(
    (state, { item }) => {
        return {
            item,
        };
    },
    dispatch => bindActionCreators({

    },
    dispatch),
)(VesselListRow);



// WEBPACK FOOTER //
// ./app/components/Vessels/List/Row.jsx